export const REQUEST_METHOD = {
    POST: "POST",
    DELETE: "DELETE",
    GET: "GET",
    PUT: "PUT"
};

export const REQUEST_BODY_TYPE = {
    FORM_DATA: "FORM_DATA"
  };